
import { Candidate } from "../types";
import { Mail, Phone, Linkedin } from "lucide-react";

interface ContactInfoDisplayProps {
  candidate: Candidate;
}

export const ContactInfoDisplay = ({ candidate }: ContactInfoDisplayProps) => {
  return (
    <>
      {candidate.email && (
        <div className="flex items-center gap-3 group">
          <Mail className="h-4 w-4 text-muted-foreground" />
          <a href={`mailto:${candidate.email}`} className="text-primary group-hover:underline transition-colors">
            {candidate.email}
          </a>
        </div>
      )}
      {candidate.phone && (
        <div className="flex items-center gap-3 group">
          <Phone className="h-4 w-4 text-muted-foreground" />
          <a href={`tel:${candidate.phone}`} className="text-primary group-hover:underline transition-colors">
            {candidate.phone}
          </a>
        </div>
      )}
      {candidate.linkedin_url && (
        <div className="flex items-center gap-3 group">
          <Linkedin className="h-4 w-4 text-muted-foreground" />
          <a href={candidate.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-primary group-hover:underline transition-colors">
            LinkedIn Profile
          </a>
        </div>
      )}
      {(!candidate.email && !candidate.phone && !candidate.linkedin_url) && (
          <p className="text-sm text-muted-foreground">No contact information provided.</p>
      )}
    </>
  );
};
